import { sort } from 'radash'

import {
	BookableNotPackagedFeature,
	CheckInFeature,
	TaxDto
} from '@wwt/entities/api/search-response'
import { OfferWithoutPrice } from '@wwt/entities/search-response'

import { PriceFeature } from '../types/PriceFeature'

const _getFeaturesSum = <F extends BookableNotPackagedFeature | CheckInFeature>(
	features: F[]
) => {
	const result: PriceFeature[] = []

	features.forEach(feature => {
		const selectedOption = feature.options?.find(option => option.isSelected)

		if (!selectedOption) {
			throw new Error(
				'Not found selected option in getAllFeatureSelectedOptionPrices'
			)
		}

		result.push({
			name: feature.name,
			optionName: selectedOption.name,
			amount: selectedOption.price?.amount ?? 0,
			currency: selectedOption.price?.currency
		})
	})

	return result
}

const selectedPackagePrice = (offer: OfferWithoutPrice) => {
	const bookablePackagedFeatures = offer.roomDynamic.bookablePackagedFeatures

	for (const feature of bookablePackagedFeatures) {
		for (const option of feature.options) {
			if (!option.isSelected) continue

			for (const bookablePackage of option.packages) {
				if (!bookablePackage.isSelected) continue

				return bookablePackage.price
			}
		}
	}

	throw new Error('Not found selected package')
}

const taxesByIncluded = (taxes: TaxDto[] | undefined, isIncluded: boolean) => {
	if (taxes === undefined) return []

	return taxes.filter(tax => tax.isIncluded === isIncluded)
}

const sortByAmount = <F extends BookableNotPackagedFeature | CheckInFeature>(
	features: F[]
) => {
	return sort(_getFeaturesSum(features), feature => feature.amount, true)
}

const notPackagedPrices = (offer: OfferWithoutPrice) => {
	return sortByAmount(offer.roomDynamic.bookableNotPackagedFeatures ?? [])
}

const checkInFeaturePrices = (offer: OfferWithoutPrice) => {
	return sortByAmount([
		...(offer.hotelDynamic.checkInFeatures ?? []),
		...(offer.roomDynamic.checkInFeatures ?? [])
	])
}

export const OfferPriceUtils = {
	selectedPackagePrice,
	taxesByIncluded,
	sortByAmount,
	notPackagedPrices,
	checkInFeaturePrices
}
